import React from 'react';
import { Row, Col } from '@teko/ui';
import { Image } from '@teko/ds-foundation';
import { ProductName } from '../../Common/ProductName/ProductName.es.js';
import { ProductPrice } from '../../Common/ProductPrice/ProductPrice.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const PrintBuildPcItem = ({
  product,
  quantity
}) => {
  var _a, _b, _c;
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, {
    col: 1.5
  }, /* @__PURE__ */ React.createElement(Image, {
    width: 50,
    height: 50,
    src: product.imageUrl,
    objectFit: "contain",
    lazy: false
  })), /* @__PURE__ */ React.createElement(Col, {
    col: 7.5
  }, /* @__PURE__ */ React.createElement(ProductName, {
    name: product.name
  })), /* @__PURE__ */ React.createElement(Col, null, "x", quantity), /* @__PURE__ */ React.createElement(Col, {
    col: 2
  }, /* @__PURE__ */ React.createElement(ProductPrice, __spreadValues({}, {
    price: ((_a = product == null ? void 0 : product.price) == null ? void 0 : _a.latestPrice) || 0,
    discount: ((_b = product == null ? void 0 : product.price) == null ? void 0 : _b.discountPercent) || "",
    listedPrice: ((_c = product == null ? void 0 : product.price) == null ? void 0 : _c.supplierRetailPrice) || 0
  }))));
};

export { PrintBuildPcItem };
